import { Outlet } from "react-router-dom";
import './Layout.css';


const Layout = () => {

  //const year = new Date().getFullYear();

  return (
    <>

      <Outlet />

    </>
  )
};

export default Layout;